import {createSelector} from 'reselect';

import {RootState} from '/redux/reducer';

import {AbacusState} from '/types/abacus.types';

const DEFAULT_ABACUS_STATE: AbacusState = {
  isLoading: false,
  error: null,
  conversationId: null,
  externalSessionId: null,
  lastResponse: null,
  messages: [],
  lastUpdatedAt: null,
};

export const selectAbacusState = (state: RootState): AbacusState =>
  state.abacus ?? DEFAULT_ABACUS_STATE;

export const selectAbacusMessages = createSelector(
  selectAbacusState,
  abacus => abacus.messages,
);

export const selectAbacusIsLoading = createSelector(
  selectAbacusState,
  abacus => abacus.isLoading,
);

export const selectAbacusError = createSelector(
  selectAbacusState,
  abacus => abacus.error,
);

export const selectAbacusConversationId = createSelector(
  selectAbacusState,
  abacus => abacus.conversationId,
);

export const selectAbacusExternalSessionId = createSelector(
  selectAbacusState,
  abacus => abacus.externalSessionId,
);

export const selectAbacusLastResponse = createSelector(
  selectAbacusState,
  abacus => abacus.lastResponse,
);

export const selectAbacusLastUpdatedAt = createSelector(
  selectAbacusState,
  abacus => abacus.lastUpdatedAt,
);
